import type { MigrationStrategies } from 'rxdb';
import type { PmCheckList } from './pmCheckList.types';

export const pmCheckListMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: PmCheckList) => {
    const newDoc = {
      ...oldDoc,
      site: 0,
      discipline: 0,
      isActive: false,
      children:
        oldDoc?.children?.length > 0
          ? oldDoc?.children?.map(child => ({ ...child, site: 0, discipline: 0, isActive: false }))
          : [],
    };
    return newDoc;
  },
};
